import { Link } from 'react-router-dom'
import { formatDistanceToNow } from 'date-fns'

interface Achievement {
  id: number
  code: string
  name: string
  category: string
  tier: string
  earned_at: string
}

interface RecentAchievementsProps {
  achievements: Achievement[]
}

const categoryIcons: Record<string, string> = {
  growth: '🌱',
  consistency: '💪',
  skill: '🧠',
  challenge: '⚔️',
}

const tierColors: Record<string, string> = {
  bronze: 'text-tier-bronze border-tier-bronze',
  silver: 'text-tier-silver border-tier-silver',
  gold: 'text-tier-gold border-tier-gold',
}

export default function RecentAchievements({ achievements }: RecentAchievementsProps) {
  if (achievements.length === 0) {
    return (
      <div className="text-center py-8 text-gray-400">
        <p>No achievements yet</p>
        <p className="text-sm mt-1">Complete challenges to earn badges!</p>
      </div>
    )
  }

  return (
    <div className="space-y-3">
      {achievements.slice(0, 3).map((achievement) => (
        <div
          key={achievement.id}
          className={`flex items-center gap-3 p-3 bg-gray-700/50 rounded-lg border ${tierColors[achievement.tier] || 'border-gray-600'}`}
        >
          <div className="text-2xl">
            {categoryIcons[achievement.category] || '🏆'}
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="font-medium truncate">{achievement.name}</h4>
            <p className="text-xs text-gray-400">
              {formatDistanceToNow(new Date(achievement.earned_at), { addSuffix: true })}
            </p>
          </div>
          <div className={`text-xs font-medium uppercase ${tierColors[achievement.tier] || ''}`}>
            {achievement.tier}
          </div>
        </div>
      ))}

      {achievements.length > 3 && (
        <Link
          to="/student/achievements"
          className="block text-center text-sm text-quest-primary hover:underline"
        >
          View all {achievements.length} achievements →
        </Link>
      )}
    </div>
  )
}
